import axios from "./axiosInstance";

const toIso = (value) => (value ? new Date(value).toISOString() : undefined);

// ─── Venue ────────────────────────────────────────────────────────────────────

export const getEventApplicants = (eventId, occurrenceStart) =>
  axios
    .get(`/opportunities/event/${eventId}/applicants`, {
      params: occurrenceStart ? { occurrenceStart: toIso(occurrenceStart) } : {},
    })
    .then((r) => r.data);

export const acceptApplicant = (slotId, applicantId, occurrenceStart) =>
  axios
    .post(`/opportunities/slots/${slotId}/accept/${applicantId}`, {
      occurrenceStart: toIso(occurrenceStart),
    })
    .then((r) => r.data);

export const declineApplicant = (slotId, applicantId, occurrenceStart) =>
  axios
    .post(`/opportunities/slots/${slotId}/decline/${applicantId}`, {
      occurrenceStart: toIso(occurrenceStart),
    })
    .then((r) => r.data);

export const reopenSlot = (slotId, occurrenceStart) =>
  axios
    .post(`/opportunities/slots/${slotId}/reopen`, {
      occurrenceStart: toIso(occurrenceStart),
    })
    .then((r) => r.data);

// ─── Performer ────────────────────────────────────────────────────────────────

export const getOpportunities = ({ from, to } = {}) =>
  axios
    .get("/opportunities", {
      params: {
        from: toIso(from),
        to: toIso(to),
      },
    })
    .then((r) => r.data);

export const applyToSlot = (slotId, note = "", occurrenceStart) =>
  axios
    .post("/opportunities/apply", {
      slotId,
      note,
      occurrenceStart: toIso(occurrenceStart),
    })
    .then((r) => r.data);

export const withdrawApplication = (applicationId) =>
  axios.delete(`/opportunities/apply/${applicationId}`).then((r) => r.data);

export const getMyApplications = () =>
  axios.get("/opportunities/my-applications").then((r) => r.data);
